import React, { useState ,useEffect } from "react";
import {useSearchParams ,useNavigate } from "react-router-dom";



const ResultsShownFilter = ({ filteredProductsCount, resPerPage }) => {
  const navigate = useNavigate();
  
  const [availability, setAvailability] = useState(false);
  const handleAvailability = () => {
    setAvailability(!availability);
  };

  const [currentPage, setCurrentPage] = useState(resPerPage);
  let [searchParams] = useSearchParams();
  const selectpage = Number(searchParams.get("select")) || 1;

 useEffect(() => {
   setCurrentPage(selectpage);
 }, [selectpage]);
  
    const setCurrentPageNo = (pageNumber) => {
      setCurrentPage(pageNumber);

          // alert(pageNumber); // You can remove this line after testing

      if (searchParams.has("select")) {
        searchParams.set("select", pageNumber);
      } else {
        searchParams.append("select", pageNumber);
      }

      const path = window.location.pathname + "?" + searchParams.toString();
      // alert(path); // You can remove this line after testing
      navigate(path);
    };


  return (
    <div className="w-full border-b border-gray-200 flex items-center justify-between py-4 px-2 md:px-0">
      <p className="hidden md:block text-gray-800 font-bold text-sm">{filteredProductsCount} Results Shown</p>

      <div className="flex items-center gap-2">
        <label htmlFor="toggle" className="cursor-pointer text-[#2684fe] font-bold text-lg md:text-sm">
          Availability
        </label>
        <div className="flex items-center gap-2">
          <input
            onClick={handleAvailability}
            type="checkbox"
            id="toggle"
            className="hidden group"
          />
          <div
            onClick={handleAvailability}
            className={`w-[50px] h-6 relative rounded-full cursor-pointer transition-colors duration-300 ${
              availability ? "bg-[#2684fe]" : "bg-slate-200"
            }`}
          >
            <div
              className={`w-5 h-5 absolute top-0.5 left-0.5 rounded-full shadow-sm transform bg-white transition-transform duration-300 ease-in-out ${
                availability ? "translate-x-6" : "translate-x-0"
              }`}
            ></div>
          </div>
        </div>
      </div>

      <div className="flex gap-2 items-center text-sm text-gray-700">
        <p className="font-bold text-gray-800">Result Per Page</p>
        { resPerPage &&
        <select
          onChange={(e) => setCurrentPageNo(e.target.value)}
          value={currentPage}
          className="shrink-0 w-[60px] bg-blue-50 border border-blue-100 rounded-md px-2 py-1 focus:outline-none font-bold"
          >
          <option value="1">20</option>
          <option value="2">40</option>
          <option value="3">60</option>
          <option value="4">80</option>
          <option value="5">100</option>
          </select>
        }
      </div>
    </div>
  );
};

export default ResultsShownFilter;
